<template>
  <div class="entirewrapper">
    <nav class="ms-auto" role="navigation">
      <ul class="navbar-nav" aria-label="upper navigation bar">
        <!-- search bar -->
        <li v-if="!administrator" class="nav-item">
          <button class="commBtn" @click="callPatient">
            <font-awesome-icon :icon="['fas', 'phone']" class="icon" />
          </button>
        </li>
        <li v-if="!administrator" class="nav-item">
          <button class="commBtn" @click="showText">
            <font-awesome-icon :icon="['fas', 'comment']" class="icon" />
          </button>
        </li>
        <!-- <li aria-label="search">
        <form class="form-inline">
          <input class="form-control mr-sm-2 form-control-sm" type="search" placeholder="Search" aria-label="Search">
          <button class="icon--search" type="submit"><font-awesome-icon icon="search" class="icon" /></button>
        </form>
      </li> -->
        <!-- Gated on the directive_read privilege (NOT role) so any privilege-holder,
             including admins, sees it. -->
        <li v-if="canReadDirectives" class="nav-item">
          <span
            @click="getDirectives()"
            class="nav-link"
            :class="{
              'nav-link--directive-active': directivesState === 'active',
              'nav-link--directive-pending': directivesState === 'pending',
              'nav-link--directive-neutral': directivesState === 'none',
            }"
            data-bs-toggle="collapse"
            data-bs-target=".navbar-collapse.show"
            >Directives<directives-nav-badge @state-change="directivesState = $event" /></span
          >
        </li>
        <li class="nav-item">
          <button type="button" class="nav-link help-nav-btn" @click="openGlobalHelp">Help</button>
        </li>
        <li class="nav-item dropdown-li">
          <a
            class="nav-link name"
            :class="{ 'router-link-active': isSubMenuActive('user') }"
            >{{ displayUserName }}
            <font-awesome-icon :icon="['fas', 'caret-down']"
          /></a>
          <ul class="dropdown-li-ul" aria-label="dropdown">
            <li v-if="!viewingPatientChart" class="dropdown-li-ul-li">
              <router-link
                to="/user/profile"
                @click="closeNavbar"
                data-toggle="collapse"
                data-target=".navbar-collapse.show"
                >Profile</router-link
              >
            </li>
            <li v-if="!viewingPatientChart" class="dropdown-li-ul-li">
              <router-link
                to="/user/contact"
                @click="closeNavbar"
                data-toggle="collapse"
                data-target=".navbar-collapse.show"
                >Contact</router-link
              >
            </li>
            <li v-if="!viewingPatientChart" class="dropdown-li-ul-li">
              <router-link
                to="/user/devices"
                @click="closeNavbar"
                data-toggle="collapse"
                data-target=".navbar-collapse.show"
                >Devices</router-link
              >
            </li>
            <li class="dropdown-li-ul-li">
              <a role="button" @click="handleLogout">Log Out</a>
            </li>
          </ul>
        </li>
      </ul>

      <div id="send-text-modal" class="send-text-modal" :style="{ display: 'none' }">
        <div class="inner-text-modal">
          <div class="form-group2">
            <label>Enter text body</label>
            <input type="text" required v-model="txtMsg" class="form-control2" />
          </div>
          <div class="btn-group">
            <button type="submit" class="btn btn-primary" @click="sendText">Send</button>
            <button type="button" class="btn btn-secondary" @click="closeText">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </nav>
    <!-- Modern Floating Message Widget -->
    <floating-message-widget ref="messageWidget" />
    <!-- Mobile Message Widget -->
    <mobile-message-widget ref="mobileMessageWidget" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { placePhoneCall, sendTextMessage } from "@/api/smsApi";

// Outside a chart there is no patient to reach: allData.patient and getUser
// are the signed-in person, so the buttons would text or ring them.
const OPEN_A_CHART = "Open a patient's chart to call or text them.";
import { messagingSender } from "@/utils/messagingSender";
//import $ from "jquery";
import router from "@/router";
import { getAdministrator, isViewingPatientChart } from "@/data/getters";
import { Collapse } from "bootstrap";
import FloatingMessageWidget from "@/components/private-layouts/message/FloatingMessageWidget";
import MobileMessageWidget from "@/components/private-layouts/message/MobileMessageWidget";
import DirectivesNavBadge from "./DirectivesNavBadge.vue";
import { exitPatientChart } from "@/api/sessionApi";
import { usePrivilegesStore } from "@/stores/privileges";
import { useSessionStore } from "@/stores/session";
import { usePatientContextStore } from "@/stores/patientContext";
import { useHelpContentStore } from "@/stores/helpContentStore";
import { mapState } from "pinia";
import { PRIVILEGES } from "@/constants/privileges";
import { h } from "vue";
import $ from "jquery";
import "datatables.net-dt/js/dataTables.dataTables";
import DataTable from "datatables.net-dt";
export default {
  name: "NavigationBarTop",
  components: {
    "floating-message-widget": FloatingMessageWidget,
    "mobile-message-widget": MobileMessageWidget,
    "directives-nav-badge": DirectivesNavBadge,
  },
  data() {
    return {
      txtMsg: "Please visit the Erriff Health application.",
      // user: this.$store.getters['login/getUser'],
      // data: this.$store.getters['login/getAllData']
      directivesState: "none",
    };
  },
  computed: {
    ...mapGetters("login", {
      user: "getUser",
      allData: "getAllData",
    }),
    // mapState, so the chrome re-renders the moment `GET /me` answers or a
    // profile save renames the person.
    ...mapState(useSessionStore, {
      sessionDisplayName: "displayName",
      sessionOrganizationNumber: "organizationNumber",
    }),
    administrator: function () {
      return getAdministrator(this.allData);
    },
    manager: function () {
      return this.allData.manager;
    },
    viewingPatientChart: function () {
      return isViewingPatientChart(this.allData);
    },
    /** The open chart. `getUser` is the signed-in person here, never the patient. */
    chartPatient() {
      return usePatientContextStore().patient;
    },
    /**
     * The id of the patient the phone and text buttons reach. Only while
     * charting: otherwise there is no patient to reach, and the bridge names
     * the recipient by this id rather than by a number.
     *
     * `allData.patient` is the chart in view in both backends — pacmny-be's
     * blob and the port's patient context (`login/getAllData`) — and its
     * `externId` is the id the recipient is named by.
     */
    patientId() {
      if (!this.viewingPatientChart) {
        return "";
      }
      return String(this.allData?.patient?.externId ?? this.chartPatient?.id ?? "").trim();
    },
    /**
     * The patient's number on file; the recipient named by patientId wins.
     * Read off the chart, never off `getUser`: in the port that is the signed-in
     * staff member, and a fallback to it would text the caller's own phone.
     */
    patientPhone() {
      const patient = this.allData?.patient || {};
      return patient.phone1 || patient.phone2 || this.chartPatient?.phone || this.chartPatient?.phone_secondary || "";
    },
    /** The caller's profile phone: the staff member's while charting (utils/messagingSender.js). */
    callerPhone() {
      return messagingSender(this.allData).phone;
    },
    canCommunicateWithPatients() {
      return usePrivilegesStore().effectiveGranted(PRIVILEGES.COMMUNICATE_WITH_PATIENTS);
    },
    canReadDirectives() {
      return usePrivilegesStore().effectiveGranted(PRIVILEGES.DIRECTIVE_READ);
    },
    /** The signed-in person's organization number, from the session (D4). */
    accountnumber() {
      const number = this.sessionOrganizationNumber;
      return number === null || number === undefined ? "" : String(number);
    },
    /**
     * The account-menu name: always the signed-in user, including while
     * charting a patient — main's `manager.name` while a chart is open, and
     * main's MySQL self after #321. On the port both are the session's own
     * `GET /me` (decision D4): never `allData`, whose `patient` is the open
     * chart, and blank rather than a guess until `/me` has answered.
     */
    displayUserName() {
      return this.sessionDisplayName || "";
    },
  },
  
  mounted() {
    console.log('NavigationBarTop mounted');
    console.log('Screen width:', window.innerWidth);
    console.log('Is mobile:', window.innerWidth <= 768);
  },
  
  methods: {
    ...mapActions("login", ["logout", "updateApplicationModel"]),
    // See NavigationBar.vue — `/logout` is the only RP-initiated sign-out.
    handleLogout() {
      this.$router.push("/logout");
    },
    handleRevert() {
      const loader = this.$loading.show(
        {},
        {
          after: () => h("div", {}, "Reverting back..."),
        }
      );

      exitPatientChart()
        .then(() => {
          return this.updateApplicationModel();
        })
        .then(() => {
          window.location.hash = "null";
          window.location.reload();
        })
        .catch((err) => {
          console.error(err);
          this.$toast.add({
            severity: "error",
            summary: "Revert failed",
            detail: err,
            life: 3000,
          });
        })
        .finally(() => {
          loader.hide();
        });
    },
    isSubMenuActive(parentPath) {
      return this.$route.path.indexOf(parentPath) === 1;
    },
    getDirectives() {
      this.$router.push({ name: "DirectivesNavigation" });
    },
    /** Opens the global (navbar) help article. */
    openGlobalHelp() {
      useHelpContentStore().openHelp("global", {
        accountnumber: this.accountnumber,
        allData: this.allData,
      });
    },
    closeNavbar() {
      let navbar = document.querySelector(".navbar-collapse.show");
      if (navbar) {
        new Collapse(navbar, {
          toggle: false,
        }).hide();
      }
    },
    async callPatient() {
      if (!this.canCommunicateWithPatients) {
        alert("You do not have permission to contact the patient here.");
        return;
      }
      if (!this.viewingPatientChart) {
        alert(OPEN_A_CHART);
        return;
      }
      if (!this.patientId && !this.patientPhone) {
        alert("This patient has no phone number associated with their account.");
        return;
      }
      // keyon rings the patient named by patientId at the number on its own
      // record, and connects the call to one of the caller's own numbers on
      // its record - callerPhone when it is one of them - so neither profile
      // phone being empty is a reason to stop here. Connecting only when keyon
      // says Twilio took the call; otherwise its reason (src/api/smsApi.js).
      const result = await placePhoneCall(this.patientPhone, this.callerPhone, { patientId: this.patientId });
      alert(result.ok ? "Connecting call..." : result.message);
    },
    async sendText() {
      if (!this.viewingPatientChart) {
        alert(OPEN_A_CHART);
        return;
      }
      if (!this.patientId && !this.patientPhone) {
        alert("This patient has no phone number associated with their account.");
        return;
      }
      // Sent only when keyon says Twilio took it, to the number on keyon's
      // record of the patient named by patientId. A refusal or a failure says
      // why and leaves the box open with the message in it.
      const result = await sendTextMessage(this.patientPhone, this.txtMsg, { patientId: this.patientId });
      if (!result.ok) {
        alert(result.message);
        return;
      }
      alert("Text sent");
      this.closeText();
    },
    showText() {
      if (!this.canCommunicateWithPatients) {
        alert("You do not have permission to contact the patient here.");
        return;
      }
      if (!this.viewingPatientChart) {
        alert(OPEN_A_CHART);
        return;
      }
      $("#send-text-modal").css("display", "flex");
    },
    closeText() {
      this.txtMsg = "Please visit the Erriff Health application.";
      $("#send-text-modal").css("display", "none");
    },
  },
};
</script>

<style scoped lang="scss">
$color-hover: darken(#ffffff, 10%);

@import "../../../stylesheets/modules/dropdown";

.commBtn {
  background-color: transparent;
  border: none;
}

.navbar-nav {
  font-size: 0.95rem;
  font-family: "Noto Sans", system-ui, sans-serif;
  /* Bootstrap's expanded navbar-nav is a nowrap flex row of nowrap links, so
     when the row doesn't fit (the patient-chart nav has the most
     items) it widens the document instead of the navbar — the page grows a
     horizontal scroll and every full-width band below (utility bars, the
     patient-view banner) ends short of the document edge. Wrap onto a second
     line inside the bar instead. */
  flex-wrap: wrap;
  justify-content: flex-end;
  row-gap: 2px;

  .nav-link {
    color: #fff;
    border-bottom: 1px solid transparent;
    cursor: pointer;
    display: inline-block;
    padding: 0.25rem 0.5rem;
    border-radius: 4px;
    transition: background-color 0.15s ease;
    font-weight: 500;

    &:hover {
      background-color: rgba(75, 156, 165, 0.35);
    }

    &.nav-link--directive-active {
      background-color: #4fa56d;
      box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.5);

      &:hover {
        background-color: lighten(#4fa56d, 6%);
      }
    }

    &.nav-link--directive-pending {
      background-color: #4b9ca5;
      box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.5);

      &:hover {
        background-color: lighten(#4b9ca5, 6%);
      }
    }

    &.nav-link--directive-neutral {
      font-weight: 700;
    }
  }
}

.icon {
  color: #fff;
}

.icon--search {
  background-color: transparent;
  border: none;
  cursor: pointer;

  &:hover {
    color: $color-hover;
    background-color: transparent;
  }
}

.router-link-active {
  border-bottom: 2px solid #cb5f50 !important;
}

.send-text-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
}

.inner-text-modal {
  background: #fff;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
  max-width: 500px;
  width: 100%;
}

.form-group {
  margin-bottom: 20px;
}

.form-group2 label {
  display: block;
  margin-bottom: 5px;
  font-weight: 600;
  font-size: 14px;
}

.form-control2 {
  display: block;
  width: 100%;
  height: 40px;
  padding: 10px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-shadow: none;
}

.btn-group {
  display: flex;
  justify-content: flex-end;
}

.btn-primary,
.btn-secondary {
  height: 40px;
  padding: 0 20px;
}
.entirewrapper {
  margin-left: auto;
}

/* Mobile/Desktop Widget Visibility */
@media (max-width: 768px) {
  .floating-message-widget {
    display: none !important;
  }
  
  .mobile-message-widget {
    display: block !important;
    visibility: visible !important;
  }
}

@media (min-width: 769px) {
  .floating-message-widget {
    display: block !important;
  }
  
  .mobile-message-widget {
    display: block !important; /* TEMPORARY: Show mobile widget on all screen sizes */
    visibility: visible !important;
  }
}

.help-nav-btn {
  border: none;
  background: transparent;
  cursor: pointer;
}
/*.msgIco {
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
    background-color: red;
    color: white;
    border-radius: 50%;
    padding: 5px 10px;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    width: 24px;
    height: 24px;
    line-height: 24px;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
}*/
</style>
